import { render, staticRenderFns } from "./modalidades.vue?vue&type=template&id=5f41ea81&"
import script from "./modalidades.vue?vue&type=script&lang=js&"
export * from "./modalidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports